import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';

const consumerCommunicationStatusKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys] as const,
  });

export { consumerCommunicationStatusKeys };
